module.exports = __webpack_public_path__ + "img/bg-sti-summary-stt.3273bf02.svg";